import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import { colors, radius, spacing, typography } from '../theme/tokens';
import { t } from '../i18n';

export const QUANTIFY_HINT =
  t('editors.quantifyHint');

// Encadré d'aide permanent (charte verte) sous les descriptions d'expériences/projets.
export function QuantifyHint({ testID }: { testID?: string }) {
  return (
    <View testID={testID} style={styles.box}>
      <Text style={styles.icon}>↗</Text>
      <Text style={styles.text}>{QUANTIFY_HINT}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    backgroundColor: colors.greenSoft,
    borderStartWidth: 3,
    borderStartColor: colors.green,
    borderRadius: radius.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
  },
  icon: { fontSize: typography.bodyMd.size, color: colors.green, fontWeight: '700' },
  text: { flex: 1, fontSize: typography.small.size, color: colors.green },
});
